import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  container: {
    margin: 0,
    height: 478,
    maxHeight: 478,
    width: 335,
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 196px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  image: {
    width: '100%',
    padding: '0 !important',
    margin: 0,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  content: {
    padding: theme.spacing(0.5, 0.5, 0, 0.5),
  },
  body: {
    minHeight: '100%',
  },
  iconsGridItem: {
    width: '100%',
  },
  imageGrid: {
    padding: 0,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  footer: {
    width: '100%',
    position: 'sticky',
    bottom: 0,
    left: 0,
    background: theme.palette.backgroundColor.secondary,
    borderTop: `1px solid ${theme.palette.backgroundColor.main}`,
  },
  socialMediaRow: {
    borderTop: `1px solid ${theme.color.lightGray}`,
  },
}))

export default styles
